import { ISimpleTableCellRenderProps } from "@asup/simple-table";
import { eLinkType } from "functions/api/enums";
import { ITlfItemRelationship } from "functions/api/tlfItem/TlfItemIndexReadDto";
import { TlfItemTableLinkCell } from "./TlfItemTableLinkCell";

/**
 * Table cell renderer that displays a navigation link to the parent template
 * for a TLF item, based on its BasedOn relationship.
 *
 * @param props - The component props
 * @param props.rowData - Row data containing the TLF item's relationships array
 */
export const ParentTemplateLink = (props: ISimpleTableCellRenderProps) => {
  const relationships = props.rowData["relationships"] as ITlfItemRelationship[] | undefined;
  const basedOnLink = relationships?.findLast((r) => r.linkType === eLinkType.BasedOn);

  return basedOnLink ? (
    <TlfItemTableLinkCell
      {...props}
      rowData={{
        ...basedOnLink,
        primaryHierarchyLevel: basedOnLink.linkLocation?.linkLevel,
      }}
    />
  ) : (
    <></>
  );
};

ParentTemplateLink.displayName = "ParentTemplateLink";
